export const SET_REGIONS = 'SET_REGIONS';
export const SET_SELECTED_COUNTRY = 'SET_SELECTED_COUNTRY';
export const SET_GROUP_TYPE_FOR_SELECTED_COUNTRY = 'SET_GROUP_TYPE_FOR_SELECTED_COUNTRY';
export const SET_GROUP_TYPE = 'SET_GROUP_TYPE';

export function setRegions(regions) {
    return {
        type: SET_REGIONS,
        payload: {
            regions: regions
        }
    };
}

export function setSelectedCountry(country) {
    return {
        type: SET_SELECTED_COUNTRY,
        payload: {
            selectedCountry: country
        }
    };
}

export function setGroupTypeForSelectedCountry(groupType) {
    return {
        type: SET_GROUP_TYPE_FOR_SELECTED_COUNTRY,
        payload: {
            groupType: groupType
        }
    };
}

export function setGroupType(groupType) {
    return {
        type: SET_GROUP_TYPE,
        payload: {
            groupType: groupType
        }
    };
}
